import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { toast } from 'react-toastify';
import { matriculaService } from '../../../services/matriculaService';

/**
 * Componente que redireciona o aluno para seu progresso
 * Busca a matrícula ativa do aluno e redireciona para /academico/meu-progresso/:idMatriz
 */
const MeuProgressoRedirect = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    buscarMatriculaAtiva();
  }, []);

  const buscarMatriculaAtiva = async () => {
    try {
      setLoading(true);

      if (!user || !user.idPessoa) {
        toast.error('Usuário não identificado');
        navigate('/');
        return;
      }

      // Buscar matrículas do aluno
      const response = await matriculaService.buscarMatriculasAluno(user.idPessoa, { 
        status: 'ativa' 
      });
      
      if (response.success && response.data && response.data.length > 0) {
        // Pegar a primeira matrícula ativa
        const matriculaAtiva = response.data[0];
        
        if (matriculaAtiva.idMatrizCurricular) {
          // Redirecionar para o progresso específico
          navigate(`/academico/meu-progresso/${matriculaAtiva.idMatrizCurricular}`);
        } else {
          toast.warning('Matrícula sem matriz curricular vinculada');
          navigate('/');
        }
      } else {
        toast.warning('Você não possui matrícula ativa no momento');
        navigate('/');
      }
    } catch (error) {
      console.error('Erro ao buscar matrícula:', error);
      toast.error('Erro ao buscar matrícula ativa');
      navigate('/');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex-1 w-full max-w-full overflow-x-hidden">
        <div className="px-2 sm:px-6">
          <div className="flex justify-center items-center h-64">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
              <div className="text-gray-600">Buscando sua matrícula...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default MeuProgressoRedirect;
